import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IRole,
    IUser,
    ODataResponse,
} from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { ISelectionDiff } from '@uipath/angular/components/ui-grid';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RoleService extends ODataService<IRole, number> {
    protected _endpoint = '/odata/Roles';
    constructor(http: HttpClient) {
        super(http, MapperService.roleMap);
    }

    public getUsersIn(roleId: number, queryOptions?: ODataQueryOptions) {
        return this._http.get(this._endpoint +
            `/UiPath.Server.Configuration.OData.GetUsersForRole(key=${roleId})${this.getQueryString(queryOptions)}`)
            .pipe(
                map(res => this._mapData<IUser>(res, MapperService.userMap)),
            ) as Observable<ODataResponse<IUser>>;
    }

    public getUserIdsForRole(roleId: number) {
        const endpoint = `${this._endpoint}/UiPath.Server.Configuration.OData.GetUserIdsForRole(key=${roleId})`;

        return this._http
            .get<{ value: number[] }>(endpoint)
            .pipe(
                map(data => data.value.map(id => ({ id }))),
            );
    }

    public setUsers(roleId: number,
        { add, remove }: ISelectionDiff<IUser>) {
        const payload = {
            addedUserIds: add.map(e => e.id),
            removedUserIds: remove.map(e => e.id),
        };

        return this._http.post(
            `${this._endpoint}(${roleId})/UiPath.Server.Configuration.OData.SetUsers`,
            JSON.stringify(payload),
        );
    }

    public suggest = (searchTerm?: string, fetchSize: number = 20, skip: number = 0, { useId } = { useId: false }) => {
        const queryOptions: ODataQueryOptions = {
            orderBy: ['Name'],
            top: fetchSize,
            skip,
        };

        if (searchTerm) {
            queryOptions.filter = {
                DisplayName: {
                    contains: searchTerm,
                },
            };
        }

        return this.get(queryOptions)
            .pipe(
                map(
                    ({ data, total }) =>
                        ({
                            total,
                            data: data.map(
                                role => ({
                                    id: useId ? role.id : role.name,
                                    text: role.name,
                                }),
                            ),
                        }),
                ),
            );
    }
}
